import React from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { useIonRouter } from '@ionic/react';
import ConversationThread from '../components/ConversationThread';

interface LocationState {
  contactId?: string;
  contactName?: string;
  isBlankShell?: boolean;
  avatarUrl?: string;
  realConversationId?: string;
  initialChannel?: 'chat' | 'email' | 'sms';
  initialFromEmail?: 'scheduling' | 'billing' | 'support';
  smsPhones?: string[];
}

const Conversation: React.FC<{ inboxRoute?: string }> = ({ inboxRoute = '/tabs/inbox' }) => {
  const { id: urlId } = useParams<{ id: string }>() as { id: string };
  const ionRouter = useIonRouter();
  const location = useLocation();
  const state = location.state as LocationState | undefined;

  return (
    <ConversationThread
      id={urlId}
      onBack={() => ionRouter.push(inboxRoute, 'back')}
      onViewContact={(contactId) => ionRouter.push(`/tabs/contact/${contactId}`, 'forward', 'push')}
      initialContactId={state?.contactId}
      initialContactName={state?.contactName}
      initialAvatarUrl={state?.avatarUrl}
      initialIsBlankShell={state?.isBlankShell}
      initialRealConversationId={state?.realConversationId}
      initialChannel={state?.initialChannel}
      initialFromEmail={state?.initialFromEmail}
      initialSmsPhones={state?.smsPhones}
    />
  );
};

export default Conversation;
